let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("eRd8e")).then(() => parcelRequire('d9FJW'));